import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-display)',
	fontWeight: '800',
	color: '#2C2C2C',
	letterSpacing: '0px',
};

export const subtitleSX: SxProps<Theme> = {
	mt: '9px',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	letterSpacing: '0px',
};
